import { useUser } from '@clerk/clerk-react';
import { UserRole } from '@/types/user';

interface UseAuthReturn {
  user: ReturnType<typeof useUser>['user'];
  isLoaded: boolean;
  isSignedIn: boolean | undefined;
  verifyRole: (allowedRoles: UserRole[]) => boolean;
  getUserRole: () => UserRole;
  updateUserRole: (role: UserRole) => Promise<boolean>;
}

/**
 * Custom hook for handling authentication and user data
 * @returns {UseAuthReturn} Authentication state and methods
 */
export const useAuth = (): UseAuthReturn => {
  const { user, isLoaded, isSignedIn } = useUser();

  const getUserRole = (): UserRole => {
    return (user?.unsafeMetadata?.role as UserRole) || 'swimmer';
  };

  const verifyRole = (allowedRoles: UserRole[]) => {
    if (!user) return false;
    const userRole = getUserRole();
    return allowedRoles.includes(userRole);
  };

  const updateUserRole = async (role: UserRole) => {
    try {
      if (!user) return false;
      
      await user.update({
        unsafeMetadata: {
          ...user.unsafeMetadata,
          role
        }
      });
      return true;
    } catch (error) {
      console.error('Error updating user role:', error);
      return false;
    }
  };

  return {
    user,
    isLoaded,
    isSignedIn,
    verifyRole,
    getUserRole,
    updateUserRole
  };
};

export default useAuth; 